/**
 * Placeholder QueryProvider. The project does not currently use React Query,
 * but the new architecture expects a shared data layer provider. This
 * component keeps the API surface open for future adoption without changing
 * consumer code.
 */
export const QueryProvider = ({ children }) => children;

